/* (c) Alpas Made LLC. All rights reserved.
 *
 * Tools carousel behaviour for sections/kc-tools-carousel.liquid.
 *
 * INFINITE: the section renders the tool list three times (copy 0, 1, 2). The
 * row starts on the middle copy. Whenever scrolling settles in the first or
 * the last copy, the row jumps by exactly one copy's width with snapping and
 * smooth scrolling switched off for that one frame. The cards at the new spot
 * are identical, so the jump is invisible and the row never reaches an end.
 *
 * AUTO NEXT: every N seconds (section setting, 0 = off) the row moves one
 * card. It waits while the visitor hovers, touches, or has keyboard focus in
 * the row, while the row is off screen, while the tab is hidden, and never
 * runs with reduced motion on.
 *
 * Scoped per section; the theme editor re-renders a section in place, so each
 * copy cleans up after itself on unload.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(root) {
    if (!root || root.__kcTools) return;
    var ctl = new AbortController();
    var sig = { signal: ctl.signal };
    root.__kcTools = ctl;
    var track = root.querySelector('.tc__track');
    var prev = root.querySelector('[data-prev]');
    var next = root.querySelector('[data-next]');
    var first = root.querySelector('[data-first]');
    if (!track || !first) return;
    var cards = [].slice.call(track.querySelectorAll('.tc__card'));
    var perCopy = cards.length / 3;
    var timer = 0, settleTimer = 0, hovering = false, focused = false, touching = false, onScreen = true;

    function setWidth() {
      // Distance from a card in copy 0 to the same card in copy 1.
      return cards[perCopy].offsetLeft - cards[0].offsetLeft;
    }
    function step() {
      return cards.length > 1 ? cards[1].offsetLeft - cards[0].offsetLeft : 300;
    }
    function jumpTo(x) {
      track.classList.add('is-jumping');
      track.scrollTo({ left: x, behavior: 'auto' });
      requestAnimationFrame(function () { track.classList.remove('is-jumping'); });
    }
    function centerOn(card) {
      return card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
    }
    function normalize() {
      var w = setWidth();
      if (!w) return;
      var x = track.scrollLeft;
      var mid = centerOn(first);
      if (x < mid - w / 2) jumpTo(x + w);
      else if (x > mid + w / 2) jumpTo(x - w);
    }
    function go(dir) {
      track.scrollBy({ left: dir * step(), behavior: reduced ? 'auto' : 'smooth' });
    }

    // Start on the first real tool, centered.
    jumpTo(centerOn(first));

    track.addEventListener('scroll', function () {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(normalize, 140);
    }, { passive: true, signal: ctl.signal });
    if (prev) prev.addEventListener('click', function () { go(-1); restart(); }, sig);
    if (next) next.addEventListener('click', function () { go(1); restart(); }, sig);
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); go(1); restart(); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); restart(); }
    }, sig);
    window.addEventListener('resize', function () {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(normalize, 140);
    }, sig);

    // ------------------------------------------------------------- auto next
    var seconds = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
    function paused() {
      return hovering || focused || touching || !onScreen || document.hidden;
    }
    function tick() { if (!paused()) go(1); }
    function restart() {
      if (!seconds || reduced) return;
      clearInterval(timer);
      timer = setInterval(tick, seconds * 1000);
    }
    root.addEventListener('mouseenter', function () { hovering = true; }, sig);
    root.addEventListener('mouseleave', function () { hovering = false; }, sig);
    root.addEventListener('focusin', function () { focused = true; }, sig);
    root.addEventListener('focusout', function (e) { if (!root.contains(e.relatedTarget)) focused = false; }, sig);
    track.addEventListener('touchstart', function () { touching = true; }, { passive: true, signal: ctl.signal });
    track.addEventListener('touchend', function () { setTimeout(function () { touching = false; restart(); }, 1500); }, { passive: true, signal: ctl.signal });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) { onScreen = entries[0].isIntersecting; }, { threshold: 0.25 });
      io.observe(root);
      ctl.signal.addEventListener('abort', function () { io.disconnect(); });
    }
    ctl.signal.addEventListener('abort', function () { clearInterval(timer); clearTimeout(settleTimer); });
    restart();
  }

  function initAll() { [].slice.call(document.querySelectorAll('[data-kc-tools]')).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:unload', function (e) {
    [].slice.call(e.target.querySelectorAll('[data-kc-tools]')).forEach(function (r) {
      if (r.__kcTools && r.__kcTools.abort) r.__kcTools.abort();
    });
  });
  document.addEventListener('shopify:section:load', initAll);
})();
